<div class="main-container">
  @if (isMobileDevice && pages.length > 1) {
    <div
      class="page-selector-container"
      >
      <div style="margin-bottom: 10px">Select report page:</div>
      <mat-form-field appearance="outline">
        <mat-label>Current report page</mat-label>
        <mat-select
          formControlName="sort"
          (selectionChange)="onPageSelected($event.value)"
          [(value)]="selectedPageName"
          [disableOptionCentering]="true"
          >
          @for (page of pages; track page) {
            <mat-option [value]="page.name">
              {{ page.displayName }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  }
  @if (isValidToken) {
    <div class="report-container">
      <powerbi-report
        [embedConfig]="reportConfig"
        cssClassName="report-content"
        [phasedEmbedding]="phasedEmbeddingFlag"
        [eventHandlers]="eventHandlersMap"
        >
      </powerbi-report>
    </div>
  }
  @if (exportReportService.isExportingInProgress$ | async) {
    <div
      style="margin: 10px"
      >
      <span class="exporting-status"
        >Exporting report. Completed
        {{ exportReportService.percentageCompleted$ | async }}%</span
        >
        <mat-spinner class="update-button-spinner" diameter="24" strokeWidth="2">
        </mat-spinner>
      </div>
    }
    @if (!isValidToken) {
      <div class="no-dashboard">
        <span> Sorry, there is no Power BI report to show</span>
      </div>
    }
  </div>
